import { render, staticRenderFns } from "./ComiteTable.vue?vue&type=template&id=3b3f719d&"
import script from "./ComiteTable.vue?vue&type=script&lang=js&"
export * from "./ComiteTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports